import React from 'react';
import EventIcon from '@mui/icons-material/Event';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  { key: 'name', label: 'Name', required: true, helperText: 'e.g. "Cotton 2024-2025"' },
  { key: 'startDate', label: 'Start Date', required: true, type: 'date' },
  { key: 'endDate', label: 'End Date', required: true, type: 'date' },
];

const TimePeriodManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Time Period Management"
    icon={<EventIcon />}
    apiPath="/api/time-periods"
    fields={fields}
    entityLabel="Time Period"
  />
);

export default TimePeriodManagement;
